export default {
  default: () => import("/home/forge/demo.jmi.cloud/apps/partner/layouts/default.vue").then(m => m.default || m),
  "unauth-layout": () => import("/home/forge/demo.jmi.cloud/apps/partner/layouts/unauthLayout.vue").then(m => m.default || m)
}